import React, { useMemo } from 'react';
import {
  HomeOutlined,
  ControlOutlined,
  ClusterOutlined,
  ContainerOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MenuProps } from "antd";

export const useLeftMenuItems = () => {
  const items: MenuProps["items"] = useMemo(() => [
    {
      label: "Home",
      key: "home",
      icon: <HomeOutlined />,
    },
    {
      label: "Users",
      key: "users",
      icon: <UserOutlined />,
    },    
    {
      label: "Applications",
      key: "applications",
      icon: <ControlOutlined />,
    },

    
    
  ], []);

  return { items };
};
